/**
 * Parse tolerance display string (e.g. "10%", "0") to numeric boundary for PQR.
 * Default fallback is 0% (WPS Studio per-weld tolerance default).
 */
function parsePqrBoundary(tolerance: string, fallback = 0): number {
  const trimmed = tolerance.trim().replace(/%/g, '')
  if (trimmed === '') return fallback
  const parsed = Number(trimmed)
  if (!Number.isFinite(parsed) || parsed < 0) return fallback
  return parsed
}

export { parsePqrBoundary }
